module.exports = __webpack_public_path__ + "static/media/mariposa-corte-04.eef0a692.png";